(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const data = JSON.parse(root.querySelector('[data-product-data]').textContent);
      const select = root.querySelector('[data-variant]');
      const quantity = root.querySelector('[data-quantity]');
      const link = root.querySelector('[data-whatsapp]');
      function update(changed = false) {
        const variant = data.variants.find(v => String(v.id) === select.value);
        if (!variant) { const add=root.querySelector('[data-add]'); if(add)add.disabled=true; if(link){link.href='https://wa.me/'+(data.phone||'').replace(/\D/g,'');link.textContent='Select an option to enquire';} return; }
        root.querySelector('[data-price]').textContent = variant.price;
        const compare = root.querySelector('[data-compare]');
        compare.hidden = !variant.onSale;
        compare.textContent = variant.compare || '';
        const add = root.querySelector('[data-add]');
        if (add) { add.disabled = !variant.available; add.textContent = variant.available ? 'Add to cart' : 'Sold Out'; }
        if (link) {
          const phone = (data.phone || '').replace(/\D/g, '');
          const qty = quantity && quantity.validity.valid ? Number(quantity.value) : 1;
          const text = `Hello Hayder’s Jewellers, I would like to enquire about ${data.title}.\nOption: ${variant.title}\nQuantity: ${qty}\nUnit price: ${variant.price}\n${new URL(data.url,window.location.origin).href}?variant=${variant.id}\nPlease confirm availability and delivery.`;
          link.href = `https://wa.me/${phone}?text=${encodeURIComponent(text)}`;
          link.textContent = variant.available && variant.price !== 'Price on request' ? (link.dataset.buyLabel || 'Order on WhatsApp ↗') : (link.dataset.enquireLabel || 'Enquire on WhatsApp ↗');
        }
        if (changed) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
          if (variant.mediaId) {
            const media = root.querySelector(`#Media-${data.section}-${variant.mediaId}`);
            if (media) media.parentElement.prepend(media);
          }
        }
      }
      select.addEventListener('change', () => update(true));
      if (quantity) quantity.addEventListener('input', () => update());
      if (link) link.addEventListener('click', event => {
        if (!select.reportValidity() || (quantity && !quantity.reportValidity())) event.preventDefault();
        if (!/^[1-9]\d{7,14}$/.test((data.phone || '').replace(/\D/g, ''))) {
          event.preventDefault();
          let notice = root.querySelector('[data-phone-notice]');
          if (!notice) { notice = document.createElement('p'); notice.dataset.phoneNotice = ''; notice.setAttribute('role','status'); link.after(notice); }
          notice.textContent = 'WhatsApp enquiries are temporarily unavailable. Please contact us by email.';
        }
      });
      window.addEventListener('popstate',()=>{const id=new URL(window.location.href).searchParams.get('variant');if(data.variants.some(v=>String(v.id)===id))select.value=id;update();});
      update();
    });
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open],.nav-dropdown[open]').forEach(el => { el.open = false; el.querySelector('summary').focus(); });
  });
})();


(() => {
 function validateImage(input) {
  const form=input.closest('[data-design-form]');
  const zone=input.closest('.upload-zone');const status=zone.querySelector('[data-file-status]');
  const preview=zone.querySelector('[data-design-preview]');
  if(input.dataset.previewUrl){URL.revokeObjectURL(input.dataset.previewUrl);delete input.dataset.previewUrl;}
  preview.hidden=true;preview.removeAttribute('src');input.setCustomValidity('');status.textContent='';
  const file=input.files && input.files[0]; if(!file)return !input.required;
  let error='';
  if(!['image/jpeg','image/png'].includes(file.type))error='Please choose a JPG or PNG image.';
  else if(file.size>5*1024*1024)error='Please choose an image smaller than 5 MB.';
  else if(file.size===0)error='This image is empty. Please choose another file.';
  if(error){input.setCustomValidity(error);status.textContent=error;return false;}
  const url=URL.createObjectURL(file);input.dataset.previewUrl=url;preview.src=url;preview.hidden=false;
  status.textContent=file.name+' · '+(file.size/1024/1024).toFixed(1)+' MB';return true;
 }
 document.addEventListener('change',event=>{if(event.target.matches('[data-design-image]')){const form=event.target.closest('[data-design-form]');const inputs=[...form.querySelectorAll('[data-design-image]')];inputs.forEach(validateImage);const total=inputs.reduce((n,input)=>n+(input.files?.[0]?.size||0),0);if(total>9*1024*1024){inputs[0].setCustomValidity('Please keep the combined image size below 9 MB.');form.querySelector('[data-file-status]').textContent='Please keep the combined image size below 9 MB.';}}});
 document.addEventListener('submit',event=>{
  if(!event.target.matches('[data-design-form]'))return;
  const form=event.target,inputs=[...form.querySelectorAll('[data-design-image]')];
  const valid=inputs.map(validateImage).every(Boolean),total=inputs.reduce((n,input)=>n+(input.files?.[0]?.size||0),0);
  if(total>9*1024*1024){inputs[0].setCustomValidity('Please keep the combined image size below 9 MB.');form.querySelector('[data-file-status]').textContent='Please keep the combined image size below 9 MB.';}
  if(!valid||total>9*1024*1024||!form.checkValidity()){event.preventDefault();form.reportValidity();}
 });
})();

